<template>
  <SinglePlanLayout
    :heading=" $t('subscription.pro_only.heading')"
    :features="features"
  />
</template>

<script
  setup
  lang="ts"
>
import { useI18n } from 'vue-i18n';
import SinglePlanLayout from './SinglePlanLayout.vue';

const { t } = useI18n();

const features = [
  {
    icon: 'calendar',
    title: t('subscription.pro_only.calendar.heading'),
    features: [
      t('subscription.pro_only.calendar.feature1'),
      t('subscription.pro_only.calendar.feature2'),
      t('subscription.pro_only.calendar.feature3'),
      t('subscription.pro_only.calendar.feature4'),
    ],
    visual: '/img/subscription/salon.svg',
  },
  {
    icon: 'briefcase',
    title: t('subscription.pro_only.register.heading'),
    features: [
      t('subscription.pro_only.register.feature1'),
      t('subscription.pro_only.register.feature2'),
      t('subscription.pro_only.register.feature3'),
      t('subscription.pro_only.register.feature4'),
    ],
    visual: '/img/subscription/register.svg',
  },
  {
    icon: 'marketing',
    title: t('subscription.pro_only.marketing.heading'),
    features: [
      t('subscription.pro_only.marketing.feature1'),
      t('subscription.pro_only.marketing.feature2'),
      t('subscription.pro_only.marketing.feature3'),
      t('subscription.pro_only.marketing.feature4'),
    ],
    visual: '/img/subscription/newsletter.svg',
  },
];
</script>
